module.exports = __webpack_public_path__ + "img/catalog (2).fef5e916.jpg";